<script setup lang="ts"></script>

<template>
  <div class="mb-6 flex flex-wrap items-end text-xs xl:mb-4 sm:text-sm">
    <slot></slot>
  </div>
</template>
